// global async/await runtime — required by precompiled deps (e.g. vue-html2canvas)
// that reference regeneratorRuntime without bundling it
import 'regenerator-runtime/runtime';
import {logger, trackRouteView} from '@/utils/logger';
import Vue from 'vue';
import VueRouter from 'vue-router'
import SmdRoutingPlugin from './plugins/smd-routing-plugin'
import SmdScaffold from 'smd-vue-scaffold';
import VueCurrencyFilter from 'vue-currency-filter';
import VueSocketIO from 'vue-socket.io';
import SocketIO from 'socket.io-client';
import MQ from 'vue-match-media/src'
import SmdCommonsPlugin from './plugins/smd-commons-plugin'
import VueHtml2Canvas from 'vue-html2canvas';
import VueGtag from 'vue-gtag';

import App from './App.vue';
import router from './router';
import store from './store';

router.afterEach((to) => {
  trackRouteView(to);
});

import TextString from '@/components/text-string';
import FullScreenLoader from '@/components/common/full-screen-loader';

import 'smd-vue-scaffold/dist/smd-vue-scaffold.css';
import './assets/styles/applications.scss';

Vue.config.productionTip = false;
// swiper element (web components) — keep Vue from treating them as Vue components
Vue.config.ignoredElements = [/^swiper-/];
Vue.config.devtools = process.env.NODE_ENV !== "production";

Vue.config.errorHandler = (err, vm, info) => {
  logger.error('Vue error', {
    component: vm && vm.$options && vm.$options.name || 'unknown',
    info,
  }, err);
};

export const bus = new Vue();

Vue.use(VueRouter);
Vue.use(SmdRoutingPlugin);
Vue.use(SmdScaffold);
Vue.use(MQ);
Vue.use(SmdCommonsPlugin);
Vue.use(VueCurrencyFilter, {
  symbol: '₱',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.'
});
const socketConnection = SocketIO(process.env.VUE_APP_SOCKET, {
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 2000,
  reconnectionDelayMax: 30000,
  timeout: 10000,
});
socketConnection.on('connect_error', (err) => {
  logger.warn('socket connect_error', {message: err && err.message});
});
socketConnection.on('reconnect_error', (err) => {
  logger.warn('socket reconnect_error', {message: err && err.message});
});
socketConnection.on('reconnect_failed', () => {
  logger.error('socket reconnect_failed');
});
Vue.use(new VueSocketIO({
  debug: process.env.NODE_ENV !== 'production',
  connection: socketConnection,
}));
Vue.use(VueHtml2Canvas);

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_ID,
    params: {
      send_page_view: false,
      debug_mode: process.env.VUE_APP_DEBUG === 'true',
    },
  },
});

Vue.component('text-string', TextString);
Vue.component('full-screen-loader', FullScreenLoader);

VueRouter.prototype.absUrl = function (url, newTab = true) {
  const link = document.createElement('a')
  link.href = url
  link.target = newTab ? '_blank' : ''
  if (newTab) link.rel = 'noopener noreferrer' // IMPORTANT to add this
  link.click()
}

// Content dictionary event bus
window.CDEventBus = new Vue({
  methods: {
    emit(labelId, payload) {
      this.$emit(labelId, payload);
    },
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
  mq: {
    mobile: '(max-width: 767px)',
    mobileLandscape: '(max-height: 400px)',
    tablet: '(max-width: 800px)',
    tabletLarge: '(max-width: 1025px)',
    desktop: '(min-width: 1024px)',
    desktopMedium: '(min-width: 1230px)',
    desktopLarge: '(min-width:1441px)',
  }
}).$mount('#app');
